import React from 'react';
import { Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import loadable from '@loadable/component'
import { Loader } from '../../../../../common/components';

const EditUserDepartmentAndDesignation = loadable(
  () => import('./EditUserDepartmentAndDesignation'), {
      fallback: <Loader/>,
  }
);
const AddUserDepartmentAndDesignation = loadable(
  () => import('./AddUserDepartmentAndDesignation'), {
      fallback: <Loader/>,
  }
);
const ViewUserDepartmentAndDesignation = loadable(
  () => import('./ViewUserDepartmentAndDesignation'), {
      fallback: <Loader/>,
  }
);
const UserDepartmentAndDesignationRoutes = ({ t, alert }) => {
  return [
    <Route
      key="view_user_department_and_designation"
      exact
      path="/view/:id/designation-department"
      element={<ViewUserDepartmentAndDesignation t={t} alert={alert} />}
    />,
    <Route
      key="add_user_department_and_designation"
      exact
      path="/view/:id/designation-department/add"
      element={<AddUserDepartmentAndDesignation t={t} alert={alert} />}
    />,
    <Route
      key="edit_user_department_and_designation"
      exact
      path="/view/:id/designation-department/:departmentId/edit"
      element={<EditUserDepartmentAndDesignation t={t} alert={alert} />}
    />
  ];
};
UserDepartmentAndDesignationRoutes.propTypes = {
  t: PropTypes.func
};
export default UserDepartmentAndDesignationRoutes;
